import authInstance from "../Interceptor/interceptor";

export const addStaffEffect = (staffData) => {

    return authInstance.post("/staffs/insert", staffData);
};

export const deleteStaffEffect = (id) => {
    return authInstance.delete(`/staffs/deletestaff/${id}`);
};

export const editStaffEffect = (id, formData) => {
    return authInstance.put(`/staffs/updatestaff/${id}`, formData);
};
export const ViewStaffEffect = (staffId) => {
    return authInstance.get(`/staffs/getstaff/?staff_id=${staffId}`);
};
export const listStaffEffect = (pageNo) => {
    return authInstance.get(`/staffs/list?pageNo=${pageNo}&pagesize=10&pagination_required=true`);
};

export const historyStaffEffect = (pageNo) => {
    return authInstance.get(`/attenderbooking/getbysecirity?pageNo=${pageNo}&pagesize=10`);
};